import { render } from "./gameList.vue?vue&type=template&id=42ed6899&scoped=true"
import script from "./gameList.vue?vue&type=script&lang=js"
export * from "./gameList.vue?vue&type=script&lang=js"

import "./gameList.vue?vue&type=style&index=0&id=42ed6899&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ed6899"]])

export default __exports__